import { useEffect, useRef, useState } from 'react';

/** Returns [stickyRef, isStuck]. Place the sentinel immediately BEFORE the sticky element. */
export function useIsStuck(topOffset = 0) {
  const stickyRef = useRef<HTMLDivElement | null>(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const el = stickyRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsStuck(!entry.isIntersecting),
      { threshold: 0, rootMargin: `-${topOffset}px 0px 0px 0px` },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [topOffset]);

  return [stickyRef, isStuck] as const;
}
